/* CILSY v3.5.7 — interactivity bundle (no header/footer takeover) */
(function () {
  'use strict';

  function init() {
    document.body.classList.remove('cilsy-takeover');
    initReveals();
    initParallax();
    initBeforeAfter();
  }

  /* Reveal-on-scroll */
  function initReveals() {
    var els = document.querySelectorAll('.cilsy-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Hero parallax */
  function initParallax() {
    var wrap = document.querySelector('[data-cilsy-parallax]');
    if (!wrap) return;
    function onScroll() {
      var rect = wrap.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.06;
      wrap.style.transform = 'translate3d(0,' + offset + 'px,0)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Before/After slider */
  function initBeforeAfter() {
    var ba = document.querySelector('[data-cilsy-ba]');
    if (!ba) return;
    var beforeWrap = ba.querySelector('.cilsy-ba__before-wrap');
    var beforeImg = beforeWrap ? beforeWrap.querySelector('img') : null;
    var divider = ba.querySelector('.cilsy-ba__divider');
    var dragging = false;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      if (beforeWrap) beforeWrap.style.width = pct + '%';
      if (beforeImg && pct > 0) beforeImg.style.width = (10000 / pct) + '%';
      if (divider) divider.style.left = pct + '%';
    }
    function fromClient(x) {
      var rect = ba.getBoundingClientRect();
      setPos(((x - rect.left) / rect.width) * 100);
    }
    ba.addEventListener('mousedown', function (e) { dragging = true; fromClient(e.clientX); });
    ba.addEventListener('touchstart', function (e) { dragging = true; fromClient(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) fromClient(e.clientX); });
    window.addEventListener('touchmove', function (e) { if (dragging) fromClient(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });

    setPos(50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
